import React, { useState } from "react";
import { CheckCircle2, Info, Receipt } from "lucide-react";
import { LedgerItem } from "../pages/MyDuesPage";
import { useCreateInvoiceMutation } from "../api/billingApi";
function money(n: number, currency = "NGN") {
  return new Intl.NumberFormat("en-NG", {
    style: "currency",
    currency,
  }).format(n);
}

export default function DuesTable({ items }: { items: LedgerItem[] }) {
  const [selected, setSelected] = useState<number[]>([]);
  const [createInvoice, { isLoading }] = useCreateInvoiceMutation();
  const toggle = (id: number) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const paySingle = async (id: number) => {
    try {
      const res = await createInvoice({
        items: [{ charge_price_id: id }],
      }).unwrap();
      console.log(res, "tjos os the apmet response");

      // redirect to payment page / invoice page
      window.location.href = `/invoice/${res.id}`;
    } catch (e) {
      console.error("Payment error", e);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | PAY SELECTED
  |--------------------------------------------------------------------------
  */

  const paySelected = async () => {
    try {
      const res = await createInvoice({
        items: selected.map((id) => ({
          charge_price_id: id,
        })),
      }).unwrap();

      window.location.href = `/invoice/${res.id}`;
    } catch (e) {
      console.error("Payment error", e);
    }
  };

  if (!items?.length) {
    return (
      <div className="flex flex-col items-center py-16">
        <Receipt className="w-10 h-10 text-gray-300" />
        <p className="text-gray-400 font-bold">No charges</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      {selected.length > 0 && (
        <div className="mb-4">
          <button
            onClick={paySelected}
            disabled={isLoading}
            className="bg-black text-white px-4 py-2 rounded-xl text-sm disabled:opacity-50"
          >
            {isLoading ? "Processing..." : `Pay Selected (${selected.length})`}
          </button>
        </div>
      )}

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-gray-400 text-xs uppercase">
              <th></th>
              <th>Description</th>
              <th>Type</th>
              <th>Year</th>
              <th className="text-right">Amount</th>
              <th className="text-right">Balance</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {items.map((x) => (
              <tr key={x.id} className="border-b">
                <td>
                  {!x.already_paid && (
                    <input
                      type="checkbox"
                      checked={selected.includes(x.id)}
                      onChange={() => toggle(x.id)}
                    />
                  )}
                </td>

                <td className="font-semibold">{x.name}</td>

                <td>
                  <span className="text-xs px-2 py-1 bg-gray-100 rounded">
                    {x.type}
                  </span>
                </td>

                <td>{x.year ?? "—"}</td>

                <td className="text-right">
                  {money(x.base_amount, x.currency)}
                </td>

                <td className="text-right">{money(x.balance, x.currency)}</td>

                <td>
                  {x.already_paid ? (
                    <span className="text-green-600 flex items-center gap-1">
                      <CheckCircle2 size={14} /> Paid
                    </span>
                  ) : (
                    <span className="text-amber-600 flex items-center gap-1">
                      <Info size={14} /> Unpaid
                    </span>
                  )}
                </td>

                <td>
                  {!x.already_paid && (
                    <button
                      onClick={() => paySingle(x.id)}
                      disabled={isLoading}
                      className="text-xs bg-black text-white px-3 py-1 rounded-lg disabled:opacity-50"
                    >
                      Pay
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
